<template>
    <div class="main">
        <a-card style="border-top-right-radius: 20px; border-top-left-radius: 20px" :bordered="false">
            <div>
                <div class="actions">
                    <div @click="GotoPrev"
                        style="font-size:20px;text-decoration: none;width:30%;line-height:30px;display:flex;cursor:pointer">
                        <p>
                            <a-icon style="font-size: 15px; margin-right: 8px;" type="arrow-left" />
                        </p>
                        <p>Go Back To Orders </p>
                    </div>
                    <!-- <div>
                    <a-button style="border-raduis:6px; background: #fff;color:#0F3659" icon="edit" class="mr-4">
                        Edit
                    </a-button>
                    <a-button style="border-raduis:6px; background: #fff;color:#0F3659" icon="export">
                        Export
                    </a-button>
                </div> -->
                </div>

                <h3 style="font-size:28px;line-height:45px">Order Details for #: {{ displayInvoiceId }}</h3>

                <a-row>
                    <a-col :span="17">
                        <div style="background: #fff">
                            <p style="padding-left: 20px;color:#418a49;padding-top:10px">Order Items:</p>
                            <a-table :columns="columns" :data-source="tableData" :pagination="false" class="tableStyle">
                            </a-table>
                            <div
                                style="display:flex;justify-content: flex-end;padding-top:10px;font-size: 20px;padding-right:20px">
                                <p>Total : Ksh {{ displayToTalAmount }}</p>
                            </div>
                        </div>
                    </a-col>
                    <a-col :span="6" :offset="1">
                        <a-card style="border-radius: 20px;" :bordered="true">
                            <div style="background: #fff;padding:20px;">
                                <p style="color:#418a49">Shipping Address</p>

                                <p style="font-weight:bolder">{{ retailerDetails.name }}</p>
                                <p>{{ retailerDetails.address }}</p>
                                <p>{{ retailerDetails.phoneNumber }}</p>
                            </div>
                        </a-card>

                    </a-col>
                </a-row>
                <a-row style="margin-top:30px;">
                    <a-card style="border-radius: 20px;" :bordered="true">
                        <a-col style="margin-bottom: 10px;background: #fff" :span="17">
                            <a-row type="flex" justify="space-between" align="middle">
                                <a-col style="padding:40px" :span="10">
                                    <p style="color:#418a49;font-weight:bolder;font-size:20px;padding-bottom:20px">Notes
                                    </p>
                                    <div style="padding-top:20px;">
                                        <a-timeline class="timeline" style="font-size:20px">
                                            <a-timeline-item style="font-size:20px" color="green">
                                                <i slot="dot" style="padding-left: 25px;font-size: 50px;"
                                                    class="fas fa-truck"></i>
                                                <p style="padding-left:35px;height:100px">Fulfilled</p>
                                            </a-timeline-item>

                                            <a-timeline-item style="font-size:20px;" color="green">
                                                <i slot="dot" style="padding-left: 25px;font-size: 50px;"
                                                    class="fas fa-truck"></i>
                                                <p style="padding-left:35px;height:100px">In Transit</p>
                                            </a-timeline-item>

                                            <a-timeline-item style="font-size:20px" color="green">
                                                <i slot="dot" style="padding-left: 25px;font-size: 50px;"
                                                    class="fas fa-truck"></i>
                                                <p style="padding-left:35px;">Order Placed</p>
                                            </a-timeline-item>
                                        </a-timeline>
                                    </div>
                                </a-col>
                                <a-col :span="10">
                                    <div
                                        style="display: flex;flex-direction: column;justify-content:space-between;margin-top:70px">
                                        <div style="height: 132px;">January 22,2021 10:00:00 PM</div>
                                        <div style="height:144px">January 22,2021 10:00:00 PM</div>
                                        <div style="height:58px">January 22,2021 10:00:00 PM</div>
                                    </div>
                                </a-col>
                            </a-row>
                        </a-col>
                    </a-card>
                </a-row>
            </div>
        </a-card>
    </div>
</template>

<script>
import moment from 'moment';
import { mapActions, mapGetters } from 'vuex';
// const columns2 = [
// //   {
// //     title: 'ID',
// //     dataIndex: 'id',
// //     key: 'id',
// //   },
//   {
//     title: 'Products Name',
//     dataIndex: 'productName',
//     // width: 200,
//   },
//   {
//     title: 'Expected At',
//     dataIndex: 'expectedAt',
//   },
//   {
//     title: 'Status',
//     dataIndex: 'status',
//     scopedSlots: { customRender: 'status' },
//   },
//    {
//     title: 'Created At',
//     dataIndex: 'createdAt',
//   },
// ];


const columns = [
    //   {
    //     title: 'Thumb',
    //     // width: 80,
    //     key: 'thumb',
    //     scopedSlots: { customRender: 'thumb' },
    //   },
    {
        title: 'Product Name',
        dataIndex: 'productName',
        // width: 200,
    },
    {
        title: 'Category',
        dataIndex: 'category',
        //  width: 150,
    },
    {
        title: 'Supplier',
        dataIndex: 'supplierName',
        //  width: 150,
    },
    {
        title: 'Quantity',
        dataIndex: 'quantity',
        //  width: 150,
    },
    {
        title: 'Amount (Ksh)',
        dataIndex: 'amount',
        // width: 150,
    },
    //   {
    //     title: 'Commission(Ksh)',
    //     dataIndex: 'commission',
    //     //  width: 150,
    //   },
    {
        title: 'Sales',
        dataIndex: 'netSales',
        // width: 150,
    },
    //   {
    //     title: 'Action',
    //     key: 'action',
    //     dataIndex: 'action',
    //     scopedSlots: { customRender: 'action' }
    //   },
];



export default {
    name: "OrdersDetails",
    // props: ['items'],
    data() {
        return {
            items: {},
            columns,
            // columns2,
            tableData: [],
            // tableData2: [],
            item: {},
            retailerDetails: {}
        };
    },
    computed: {
        ...mapGetters(['getOrder']),
        formatDateTime() {
            return moment(this.item.createdAt).format("DD-MM-YYYY HH:mm:ss A");
        },
        displayInvoiceId() {
            return this.item.id
        },
        displayToTalAmount() {
            // console.log(" items  | ", this.items);
            // console.log("in computed item |", this.newRequestInventoryform.request)
            const itemAmount = this.items.requestLines.map(item => parseFloat(item.netSales))
            // console.log("in each itemAmount |", itemAmount)
            const totalAmt = itemAmount.reduce((acc, item) => acc + item, 0);
            // console.log("in computed totalAmt |", totalAmt)
            return totalAmt.toLocaleString(undefined, { minimumFractionDigits: 2 })
        }
    },
    methods: {
        GotoPrev() {
            this.$router.go(-1);
        },
        ...mapActions(['getAllRetailers']),
        async getRetailerDetails() {
            const response = await this.getAllRetailers()

            if (response.status === 200) {
                this.retailerDetails = response.data.data.find(retailer => retailer.locationId === this.items.destinationLocationId)
                // console.log("retailerDetails | ", this.retailerDetails)
            } else {
                console.log("Error | ", response)
            }
        }

    },
    created() {
        // console.log("getOrder  | ", this.getOrder);
        if (this.getOrder) {
            this.items = this.getOrder
            this.item = this.items
            this.tableData = this.items.requestLines.map(row => {
                return {
                    key: row.id,
                    productName: row.productBrandName,
                    category: row.categoryName,
                    supplierName: row.supplierName ? row.supplierName : "N/A",
                    amount: row.unitPrice.toLocaleString(undefined, { minimumFractionDigits: 2 }),
                    commission: row.commission,
                    netSales: row.netSales.toLocaleString(undefined, { minimumFractionDigits: 2 }),
                    quantity: row.quantity,
                    price: parseFloat(row.unitPrice).toFixed(2),
                    total: parseFloat(parseFloat(row.unitPrice) * parseFloat(row.quantity)).toFixed(2)
                }
            })
            this.getRetailerDetails()

        }

    }

}
</script>

<style scoped>
.ant-table-wrapper {
    zoom: 1;
    background: #fff;
    margin-bottom: 30px;
}

.timeline>>>.ant-timeline-item-tail {
    position: absolute;
    top: 20px;
    left: 16px;
    border-left: 2px solid #e8e8e8;
}

.productTable>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.productTable>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.img_size {
    max-width: 75px;
    max-height: 75px;
}

.productTable>>>.ant-pagination-item-active a {
    color: #fff;
}

.productTable>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.fulfillmentTable>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.fulfillmentTable>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.fulfillmentTable>>>.ant-pagination-item-active a {
    color: #fff;
}

.fulfillmentTable>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-thead th {
    background: #c7c7c763;
    height: 63px;
}

.tableStyle>>>.ant-pagination-item-active {
    background: #418a49;
    border-color: #418a49;
}

.tableStyle>>>.ant-pagination-item-active a {
    color: #fff;
}

.tableStyle>>>.ant-table-pagination {
    float: none;
    margin: 16px 0;
    display: flex;
    justify-content: center;
}

.tableStyle>>>.ant-table-tbody>tr:hover:not(.ant-table-expanded-row):not(.ant-table-row-selected)>td {
    background: #26A246;
    color: #fff;

}

.tableStyle>>>.ant-table-thead th {
    background: #fff;
    height: 63px;
}

.tableStyle>>>.ant-table-header {
    background: #fff !important;
}
</style>